/**
 * JdCurrentOwnerRow — the JD page header's "Current Owner" row (wireframe jobs-library-ownership-v3.html):
 * the owner's name chip, with "(You)" for the owner, or "Unclaimed" in italics with its tooltip for a JD
 * nobody has claimed yet. Renders nothing when there is no owner to show.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { SbTooltip, TooltipTriggerStyled } from 'uiCore';
import { getInitials } from 'Pages/AdminSetup/components/LegalEntityManagement/helper';
import {
  CURRENT_OWNER_LABEL, TOOLTIP_UNCLAIMED, UNCLAIMED_LABEL, YOU_SUFFIX, getCurrentOwnerRow,
} from 'Utils/jdOwnership';
import {
  OwnerLabelStyled, OwnerRowStyled, PersonAvatarStyled, PersonChipStyled, UnclaimedStyled,
} from './JdCurrentOwnerRow.styles';

const JdCurrentOwnerRow = ({ jdOwnership = null, fallbackName = '' }) => {
  const row = getCurrentOwnerRow(jdOwnership, fallbackName);
  if (!row) return null;
  return (
    <OwnerRowStyled data-testid="jd-current-owner">
      <OwnerLabelStyled>{CURRENT_OWNER_LABEL}</OwnerLabelStyled>
      {row.unclaimed ? (
        <SbTooltip content={TOOLTIP_UNCLAIMED}>
          <TooltipTriggerStyled>
            <UnclaimedStyled>{UNCLAIMED_LABEL}</UnclaimedStyled>
          </TooltipTriggerStyled>
        </SbTooltip>
      ) : (
        <PersonChipStyled>
          <PersonAvatarStyled aria-hidden="true">{getInitials(row.name)}</PersonAvatarStyled>
          {row.name}
          {row.isYou && ` ${YOU_SUFFIX}`}
        </PersonChipStyled>
      )}
    </OwnerRowStyled>
  );
};

JdCurrentOwnerRow.propTypes = {
  jdOwnership: PropTypes.shape({
    isUnowned: PropTypes.bool,
    isOwner: PropTypes.bool,
    ownerName: PropTypes.string,
  }),
  fallbackName: PropTypes.string,
};

export default JdCurrentOwnerRow;
